// extracted by mini-css-extract-plugin
module.exports = {"root":"CubeName-module__root__1KLPm","name-input":"CubeName-module__name-input__1MRG7"};